import { useRef, useEffect } from "react";
import { Checkbox } from "@legal-500/legal500-design-system";
import type { ApprovalRequest } from "../../../../api/approvalRequests.service";
import { isSelectable } from "../utils";
import styles from "./CheckboxColumn.module.css";

type CheckboxColumnProps = {
  item?: ApprovalRequest;
  isSelected: boolean;
  isIndeterminate?: boolean;
  onSelect: (idOrAll: string | "all", selected: boolean) => void;
};

export function CheckboxColumn({
  item,
  isSelected,
  isIndeterminate = false,
  onSelect,
}: CheckboxColumnProps) {
  const checkboxRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (checkboxRef.current) {
      const input = checkboxRef.current.querySelector('input[type="checkbox"]') as HTMLInputElement;
      if (input) {
        input.indeterminate = isIndeterminate;
      }
    }
  }, [isIndeterminate]);

  if (!item) {
    return (
      <div className={styles.checkboxColumn} ref={checkboxRef} onClick={e => e.stopPropagation()}>
        <Checkbox
          checked={isSelected}
          onChange={e => {
            e.stopPropagation();
            onSelect("all", (e.target as HTMLInputElement).checked);
          }}
          onClick={e => e.stopPropagation()}
        />
      </div>
    );
  }

  const isDisabled = !isSelectable(item.status);

  return (
    <div className={styles.checkboxColumn} onClick={e => e.stopPropagation()}>
      <Checkbox
        checked={isSelected}
        disabled={isDisabled}
        onChange={e => {
          e.stopPropagation();
          if (!isDisabled) {
            onSelect(item.id, (e.target as HTMLInputElement).checked);
          }
        }}
        onClick={e => e.stopPropagation()}
      />
    </div>
  );
}
